import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const SaveShortcutIcon = (props: IconProps) => (
  <Icon height="16px" width="16px" viewBox="0 0 16 16" {...props}>
    <path d="M3.111 10.889V3.11H7V2H3.111C2.494 2 2 2.5 2 3.111v7.778A1.11 1.11 0 0 0 3.111 12h4.603v-1.111H3.111ZM7.783 7h-.069v.069L5.428 9.356l-.784-.784 5.462-5.46H8.11V2H12v3.889h-1.111V3.894L7.783 7ZM12.667 8.667h-1.334v2.666H8.667v1.334h2.666v2.666h1.334v-2.666h2.666v-1.334h-2.666V8.667Z" />
  </Icon>
);

export default memo(SaveShortcutIcon);
